export default __webpack_public_path__ + "static/media/marker-purple.62a44e93.png";